import React from "react";
import { Button } from "react-bootstrap";

const DevOnlyButton = ({
    onClick,
    children,
}: {
    onClick: () => void;
    children: React.ReactNode;
}) => {
    if (process.env.NODE_ENV !== "development") {
        return null;
    }

    const buttonStyle: React.CSSProperties = {
        position: "relative",
        overflow: "hidden",
    };

    const overlayStyle: React.CSSProperties = {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage:
            "repeating-linear-gradient(45deg, rgba(0,0,0,0.1), rgba(0,0,0,0.1) 10px, rgba(0,0,0,0.2) 10px, rgba(0,0,0,0.2) 20px)",
        zIndex: 1,
    };

    const textStyle: React.CSSProperties = {
        position: "relative",
        zIndex: 2,
    };

    return (
        <Button variant="warning" style={buttonStyle} onClick={onClick}>
            <div style={overlayStyle}></div>
            <span style={textStyle}>{children}</span>
        </Button>
    );
};

export default DevOnlyButton;
